// REACT
import { useContext, useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";

// ASSETS
import "../assets/styles/toolCard.css";
import languagePack from "../assets/languages/languagePack";

// ROUTES
import { basePath } from "../routes/routes";

// COMPONENTS
import ToolCard from "../components/home/ToolCard";

// CONTEXT
import { maincontext } from "../context/maincontext";
import { useRead } from "../hooks/useFetch";

export default function Home() {
    const { language, token } = useContext(maincontext)

    const tools = [
        { url: `${basePath}upload`, name: "Upload Manager", title: languagePack[language].uploadManager.title },
        { url: `${basePath}export`, name: "Export Manager", title: languagePack[language].exportManager.title },
        { url: `${basePath}productmanager`, name: "Product Manager", title: languagePack[language].productManager.title },
        { url: `${basePath}shopmanager`, name: "Shop Manager", title: languagePack[language].shopmanager.title },
        { url: `${basePath}conflictresolver`, name: "Conflict Resolver", title: languagePack[language].conflictResolver.title },
    ];

    // RENDER VARS
    const [conflictsCountRender, setConflictsCountRender] = useState(null)

    // FETCH
    const conflictsCountUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}conflicts_count`;
    const conflictsCount = useRead(conflictsCountUrl, null)

    useEffect(() => {
        if (conflictsCount.data && !conflictsCount.isPending && !conflictsCount.error) {
            setConflictsCountRender(conflictsCount.data.count)
        }
        else if (conflictsCount.error) {
            setConflictsCountRender(0)
        }
    }, [conflictsCount.data, conflictsCount.isPending, conflictsCount.error])

    return (
        <div>
            <Container className="home-container">
                <Row className="justify-content-center" style={{ height: "65vh" }}>
                    {tools.map((tool, index) => (
                        <Col key={index} md={12} lg={6} xl={5} xxl={4} className="d-flex justify-content-center align-items-center g-5">
                            {tool.name === "Conflict Resolver" ?
                                    <ToolCard
                                        url={tool.url}
                                        toolName={tool.name}
                                        toolTitle={tool.title}
                                        count={conflictsCountRender}
                                        loading={token === null || conflictsCount.isPending}
                                    /> :
                                <ToolCard
                                    url={tool.url}
                                    toolName={tool.name}
                                    toolTitle={tool.title}
                                />
                            }
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>

    );
}